import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { tap } from "rxjs";
import { CredentialService } from "src/app/modules/authentication/credential.service";
import { NotificationMessageService } from "../../services/notification.message.service";
import { UNAUTHENTICATED_RESPONSE_MESSAGES } from "./error.constants";

export const forbiddenErrorInterceptor: HttpInterceptorFn = (request, next) => {
  const messages = inject(NotificationMessageService);
  const translateService = inject(TranslateService);
  const credentialService = inject(CredentialService);

  return next(request).pipe(
    tap({
      error: (error: HttpErrorResponse) => {
        if (error.status !== 403) {
          return;
        }

        const errorResponse = error.error;

        if (credentialService.isLogoutRequest(request.url)) {
          credentialService.forceLogout();
          return;
        }

        if (
          !credentialService.getAccessToken() ||
          errorResponse.detail === UNAUTHENTICATED_RESPONSE_MESSAGES.access_expired ||
          errorResponse.detail === UNAUTHENTICATED_RESPONSE_MESSAGES.refresh_blocked
        ) {
          messages.showErrorMessage(errorResponse?.detail ?? "");
          credentialService.forceLogout();
          return;
        }

        messages.showErrorMessage(translateService.instant("USER_NOT_AUTHORIZED"));
      },
    }),
  );
};
